
import './SaveTestApp.scss';
import * as S from '../scss/theme';
import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import SaveTest_tv from './SaveTest_tv';
import SaveTest_table from './SaveTest_table';

const SaveTestApp = ({listCart, setListCart, setIsModalSaveTest}) => {

// const isModal_mun = useSelector(state => state.reduxStoreMun.isModal_mun);
const isModal_mun = false; // 임시로 false로 설정, 실제로는 Redux 상태에서 가져와야 함
const [selectedMunCode, setSelectedMunCode] = useState(null);
const [selectedNodeId, setSelectedNodeId] = useState(null);
const [testCnt, setTestCnt] = useState(0);
  
//========================================================
    return (//modal로 하는 것 포기 (로그기록으로 해야 할 듯)
    <S.Section>
      <div className='SaveTestApp'>
        
        <section className='section1'>
          <SaveTest_tv setSelectedNodeId={setSelectedNodeId} testCnt={testCnt}/>
        </section>

        <section className='section2'>
          <SaveTest_table 
          selectedNodeId={selectedNodeId} setTestCnt={setTestCnt} 
          listCart={listCart} setListCart={setListCart}
          />
        </section>

      </div>
    </S.Section>
      );
    };


export default SaveTestApp;